
import i18n from '../context/i18n';

// export const getCurrentLang = () => {
//   const storedLang = localStorage.getItem('lang');
  
//   if (storedLang) {
//     return storedLang;
//   }

//   const userLang = navigator.language.split('-')[0];


//   if (userLang === 'fr' || userLang === 'ar') {
//     return userLang;
//   }

//   return 'ar'; // Default to Arabic if no match
// };

export const getCurrentLang = () => {
  const storedLang = localStorage.getItem('lang');
  if (storedLang) return storedLang;

  const userLang = navigator.language.split('-')[0];
  const finalLang = (userLang === 'fr' || userLang === 'ar') ? userLang : 'ar';

  localStorage.setItem('lang', finalLang);
  return finalLang;
};


export const switchLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
  localStorage.setItem('lang', lang);
  document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
};
